var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActdraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_120_1978)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_1978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 10C28.552 10 29 10.448 29 11V14.757L20.001 23.757L19.995 27.995L24.241 28.001L29 23.242V29C29 29.552 28.552 30 28 30H12C11.448 30 11 29.552 11 29V11C11 10.448 11.448 10 12 10H28ZM29.778 16.808L31.192 18.222L23.414 26L21.998 25.998L22 24.586L29.778 16.808ZM20 20H15V22H20V20ZM23 16H15V18H23V16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_120_1978",
    x1: 0,
    y1: 0,
    x2: 46.1024,
    y2: 9.10665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#6E38FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F600FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_1978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActdraft);
export default __webpack_public_path__ + "static/media/actdraft.4b676de07c67947a35d42be7cafa84e1.svg";
export { ForwardRef as ReactComponent };